import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getcuentabancariacifdetalle (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getUser)
    })
  } else {
    const req = {
      url: '/api/cifempresas/getcuentabancariacifdetalle',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getcuentabancariacifdetalle }
